/* Five Origins — calculator cost per ceasca + comparator capsule (B2B).
   Toate preturile vin din data-attributes, ca sa nu existe cifre hardcodate in JS. */
(function () {
  'use strict';

  var ROOT_SEL = '[data-fo-b2b]';

  function money(n) {
    if (!isFinite(n)) n = 0;
    return n.toLocaleString('ro-RO', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' lei';
  }
  function money2(n) {
    if (!isFinite(n)) n = 0;
    return n.toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' lei';
  }
  function kg(n) {
    if (!isFinite(n)) n = 0;
    return n.toLocaleString('ro-RO', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  }
  function num(el, fallback) {
    if (!el) return fallback;
    var v = parseFloat(String(el.value).replace(',', '.'));
    return isFinite(v) && v >= 0 ? v : fallback;
  }

  function init(root) {
    if (!root || root.__foB2B) return;
    root.__foB2B = true;

    var d = root.dataset;
    var perKgRetail = parseFloat(d.perKg) || 0;      // pret retail pe kg, citit din produs
    var grams       = parseFloat(d.grams) || 8;      // grame per ceasca
    var tierKg      = parseFloat(d.tierKg) || 6;     // pragul pentru discountul mare
    var discHi      = parseFloat(d.discHi) || 20;    // % peste prag
    var discLo      = parseFloat(d.discLo) || 15;    // % sub prag
    var waNumber    = d.wa || '';
    var productName = d.product || 'cafeaua noastra';

    var $ = function (sel) { return root.querySelector(sel); };

    var inCups    = $('[data-fo-in="cups"]');
    var inDays    = $('[data-fo-in="days"]');
    var inCaps    = $('[data-fo-in="caps"]');
    var inMachine = $('[data-fo-in="machine"]');
    var rngCups   = $('[data-fo-range="cups"]');

    var out = {
      perCup:    $('[data-fo-out="perCup"]'),
      kg:        $('[data-fo-out="kg"]'),
      tier:      $('[data-fo-out="tier"]'),
      perKg:     $('[data-fo-out="perKg"]'),
      capsMonth: $('[data-fo-out="capsMonth"]'),
      oursMonth: $('[data-fo-out="oursMonth"]'),
      barCaps:   $('[data-fo-bar="caps"]'),
      barOurs:   $('[data-fo-bar="ours"]'),
      diffMonth: $('[data-fo-out="diffMonth"]'),
      diffYear:  $('[data-fo-out="diffYear"]'),
      payback:   $('[data-fo-out="payback"]'),
      paybackBox:$('[data-fo-box="payback"]'),
      wa:        $('[data-fo-out="wa"]'),
      waSub:     $('[data-fo-out="waSub"]')
    };

    function set(el, text) { if (el) el.textContent = text; }

    function compute() {
      var cups    = Math.max(0, num(inCups, 20));
      var days    = Math.max(1, num(inDays, 22));
      var capsLei = Math.max(0, num(inCaps, 0));
      var machine = Math.max(0, num(inMachine, 0));

      var cupsMonth = cups * days;
      var kgMonth   = (cupsMonth * grams) / 1000;
      var disc      = kgMonth >= tierKg ? discHi : discLo;
      var perKg     = perKgRetail * (1 - disc / 100);
      var perCup    = (perKg * grams) / 1000;

      var oursMonth = kgMonth * perKg;
      var capsMonth = cupsMonth * capsLei;
      var diffMonth = capsMonth - oursMonth;
      var diffYear  = diffMonth * 12;

      set(out.perCup, money2(perCup));
      set(out.kg, kg(kgMonth) + ' kg');
      set(out.tier, disc + '%');
      set(out.perKg, money(perKg) + '/kg');
      set(out.capsMonth, money(capsMonth));
      set(out.oursMonth, money(oursMonth));

      var max = Math.max(capsMonth, oursMonth, 1);
      if (out.barCaps) out.barCaps.style.width = (capsMonth / max * 100) + '%';
      if (out.barOurs) out.barOurs.style.width = (oursMonth / max * 100) + '%';

      set(out.diffMonth, money(Math.abs(diffMonth)));
      set(out.diffYear, money(Math.abs(diffYear)));
      root.classList.toggle('is-cheaper', diffMonth >= 0);
      root.classList.toggle('is-costlier', diffMonth < 0);

      if (out.paybackBox) {
        var show = machine > 0 && diffMonth > 0;
        out.paybackBox.hidden = !show;
        if (show) {
          var months = machine / diffMonth;
          var txt = months < 1
            ? 'sub o lună'
            : Math.ceil(months).toLocaleString('ro-RO') + (Math.ceil(months) === 1 ? ' lună' : ' luni');
          set(out.payback, txt);
        }
      }

      if (waNumber) {
        var cifre = 'Am calculat: ' + cups + ' cafele pe zi, ' + days + ' zile pe lună, adică ' + kg(kgMonth) + ' kg de cafea pe lună.';
        if (out.wa) {
          var msg =
            'Bună ziua! Vin de pe pagina Pentru afaceri de pe 5origins.com.\n' +
            cifre + '\n' +
            'Mă interesează ' + productName + ' cu discountul de ' + disc + '%. Îmi puteți face o ofertă?';
          out.wa.setAttribute('href', 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(msg));
        }
        if (out.waSub) {
          var msgSub =
            'Bună ziua! Vreau un abonament de cafea pentru firmă, de pe 5origins.com.\n' +
            cifre + '\n' +
            'Spuneți-mi, vă rog, cum funcționează abonamentul pe 6 și pe 12 luni.';
          out.waSub.setAttribute('href', 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(msgSub));
        }
      }
    }

    [inCups, inDays, inCaps, inMachine].forEach(function (el) {
      if (el) { el.addEventListener('input', compute); el.addEventListener('change', compute); }
    });

    if (rngCups && inCups) {
      rngCups.addEventListener('input', function () { inCups.value = rngCups.value; compute(); });
      inCups.addEventListener('input', function () {
        var v = num(inCups, 20);
        if (v >= parseFloat(rngCups.min) && v <= parseFloat(rngCups.max)) rngCups.value = v;
      });
    }

    compute();
  }

  function boot(scope) {
    (scope || document).querySelectorAll(ROOT_SEL).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) { boot(e.target); });
})();
